<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <h4>Categories</h4>
      <v-card flat class="card1">
        <Categories />
      </v-card>
      <h4>Monthly Perfomance</h4>
      <v-card flat class="card1">
        <MonthlyPerfomance />
      </v-card>
    </div>
    <div class="Transaction">
      <v-card class="mx-auto card cardv" max-width="344">
        <div class="ImgTrans">
          <div class="trans">
            <h4>Recent Transactions</h4>
            <small @click="navigate('transactionHistory')">see all ></small>
          </div>
        </div>
        <div class="cardRR">
          <RecentTransactions />
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import Categories from "../components/Categories";
import MonthlyPerfomance from "../components/MonthlyPerfomance";
import RecentTransactions from "../components/RecentTransactions";
export default {
  metaInfo: {
    title: "Teller/Dashboard",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    Categories,
    MonthlyPerfomance,
    RecentTransactions,
  },
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
  },
  data: () => ({}),
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.card::-webkit-scrollbar {
  display: none !important;
}

.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
  cursor: pointer;
}
.card1 {
  margin-top: 30px;
}
.cardv {
  height: 550px;
}
.cardv::-webkit-scrollbar {
  display: none !important;
}
.cardRR {
  height: 400px;
  overflow: scroll;
  padding-bottom: 10px;
}
.cardRR::-webkit-scrollbar {
  display: none !important;
}

@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }

  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
